import React, { useState } from 'react';

import { Button, Mark, Popover, Table, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { referencesApi } from '@/shared/api/references';
import { IReference } from '@/shared/types/reference.types';
import IconDelete from '@/shared/uikit/assets/icons/IconDelete.svg?react';
import IconEdit from '@/shared/uikit/assets/icons/IconEdit.svg?react';

import { IconCheck, IconX } from '@tabler/icons-react';

type ReferencesItemProps = {
	reference: IReference;
	handleEdit: (reference: IReference) => void;
};

const ReferencesItem: React.FC<ReferencesItemProps> = ({ reference, handleEdit }) => {
	const queryClient = useQueryClient();

	const [isPopoverOpen, setIsPopoverOpen] = useState(false);

	const { mutate: deleteReference, isPending: isDeletingReference } = useMutation({
		mutationFn: referencesApi.deleteReference,
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ['references'] }),
		onError: () => {
			notifications.show({
				message: 'Не удалось удалить справку',
				color: 'red',
				icon: <IconX />,
			});
		},
	});

	return (
		<Table.Tr key={reference?.id}>
			<Table.Td>
				<Text size="md" fw={600} lts="normal">
					{reference.name}
				</Text>
			</Table.Td>
			<Table.Td>
				<Text size="md" c="dimmed" lts="normal">
					{reference.description}
				</Text>
			</Table.Td>
			<Table.Td>
				<Mark
					color="#E6F7FF"
					fz={14}
					pt={3}
					pb={3}
					pr={6}
					pl={6}
					c="blue"
					style={{ border: '1px solid #91D5FF', borderRadius: '5px' }}
				>
					{reference.id}
				</Mark>
			</Table.Td>
			<Table.Td>
				<Button.Group display="flex" style={{ justifyContent: 'center' }}>
					<Button
						variant="transparent"
						size="compact-sm"
						radius="sm"
						color="balck"
						onClick={() => handleEdit(reference)}
					>
						<IconEdit fontSize={20} color="#667085" cursor="pointer" />
					</Button>
					<Popover
						position="top"
						withArrow
						shadow="md"
						opened={isPopoverOpen}
						onChange={setIsPopoverOpen}
					>
						<Popover.Target>
							<Button
								variant="transparent"
								size="compact-sm"
								radius="sm"
								color="balck"
								onClick={() => setIsPopoverOpen((prev) => !prev)}
							>
								<IconDelete fontSize={20} color="#667085" cursor="pointer" />
							</Button>
						</Popover.Target>
						<Popover.Dropdown p={8}>
							<Text size="xs">
								<Text ta="center" fz={13}>
									Удалить?
								</Text>
								<Button.Group mt={3}>
									<Button
										variant="light"
										size="compact-xs"
										radius="sm"
										onClick={() => deleteReference(reference.id)}
										loading={isDeletingReference}
									>
										<IconCheck size={16} />
									</Button>
									<Button
										variant="light"
										size="compact-xs"
										radius="sm"
										color="red"
										onClick={() => setIsPopoverOpen(false)}
										loading={isDeletingReference}
									>
										<IconX size={16} />
									</Button>
								</Button.Group>
							</Text>
						</Popover.Dropdown>
					</Popover>
				</Button.Group>
			</Table.Td>
		</Table.Tr>
	);
};

export default ReferencesItem;
